import { render, staticRenderFns } from "./OriginDestinationLabel.vue?vue&type=template&id=043cc7a8&"
import script from "./OriginDestinationLabel.vue?vue&type=script&lang=js&"
export * from "./OriginDestinationLabel.vue?vue&type=script&lang=js&"
import style0 from "./OriginDestinationLabel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports